const selectors = {
  form: 'form',
  input: 'input',
  button: '[data-submit-button]',
  error: '[data-error]',
  success: '[data-success]',
}

class NewsletterForm extends HTMLElement {
  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  hideError() {
    this.error.setAttribute('aria-hidden', true);
  }

  hideSuccess() {
    this.success.setAttribute('aria-hidden', true);
  }

  showError() {
    this.error.setAttribute('aria-hidden', false);
  }

  showSuccess() {
    this.success.setAttribute('aria-hidden', false);
  }

  async onSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    this.hideError();
    this.hideSuccess();
    this.button.setAttribute('disabled', true);
    this.button.setAttribute('aria-busy', true);
    
    const formData = new FormData(this.form);

    try {
      const response = await fetch(`/contact`, {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest',
        }
      })

      console.log('Response: ', response);
      
      if (!response.ok) {
        throw new Error('Failed to subscribe to newsletter');
      }

      this.showSuccess();

      setTimeout(() => {
        this.hideSuccess();
      }, 2000);
    } catch (error) {
      console.log('Error message: ', error.message);
      this.showError();
    } finally {
      this.button.removeAttribute('disabled');
      this.button.removeAttribute('aria-busy');
    }
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onSubmit);
  }

  removeEventListeners() {
    this.form.removeEventListener('submit', this.onSubmit);
  }

  connectedCallback() {
    this.form = this.querySelector(selectors.form);
    this.input = this.querySelector(selectors.input);
    this.button = this.querySelector(selectors.button);
    this.error = this.querySelector(selectors.error);
    this.success = this.querySelector(selectors.success);

    this.setupEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

if (!customElements.get('newsletter-form')) {
  customElements.define('newsletter-form', NewsletterForm);
}